import { FC, ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import RIStartLogo from "@/components/icons/RIStartLogo";
import { tokens } from "@/tokens";

interface NewChatViewProps {
  userName?: string;
  onExampleClick: (message: string) => void;
}

const examples = [
  "Classify a 100% Men's Linen Dress Shirt",
  "Classify Dehusked Whole Organic Coconuts",
  "Classify a Used Electric Car with over 250 miles range",
];

const NewChatView: FC<NewChatViewProps> = ({ userName = "there", onExampleClick }): ReactElement => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        pb: 8,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          width: "100%",
          maxWidth: 720,
          px: 3,
        }}
      >
        {/* Greeting */}
        <Box sx={{ textAlign: "center" }}>
          {/* Logo Orb */}
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "radial-gradient(circle at 30% 30%, #12686C 0%, #0B2B2C 100%)",
              boxShadow: "0 0 24px rgba(18, 104, 108, 0.35)",
              margin: "0 auto 20px auto",
            }}
          >
            <Box sx={{ width: 27, height: 16, color: "white" }}>
              <RIStartLogo width="100%" height="100%" />
            </Box>
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: tokens.fontWeight.bold,
              fontSize: 26,
              color: tokens.text.primary,
              letterSpacing: "-0.3px",
              mb: 0.75,
            }}
          >
            Hey {userName}, how can we help you today?
          </Typography>
          <Typography
            sx={{
              fontWeight: tokens.fontWeight.normal,
              fontSize: tokens.fontSize.lg,
              color: tokens.text.muted,
              letterSpacing: "-0.14px",
            }}
          >
            Tell us what you need, and we'll handle the rest.
          </Typography>
        </Box>

        {/* Example Cards */}
        <Box sx={{ display: "flex", gap: 1.5, width: "100%", mt: 2 }}>
          {examples.map((msg) => (
            <Box
              key={msg}
              onClick={() => onExampleClick(msg)}
              sx={{
                flex: 1,
                py: 1.5,
                px: 2,
                border: `1px solid ${tokens.border.default}`,
                borderRadius: tokens.radius.lg,
                fontSize: tokens.fontSize.sm2,
                color: tokens.text.secondary,
                cursor: "pointer",
                transition: "all 0.15s ease",
                lineHeight: 1.5,
                "&:hover": {
                  borderColor: tokens.text.disabled,
                  transform: "translateY(-1px)",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                },
              }}
            >
              {msg}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default NewChatView;
